import React from 'react';
import { NavLink } from "react-router-dom";

export const ButtonLinkVisor = ({ Href }) => {
  return (    
    <NavLink type='button' className='btn btn-sm btn-secondary rounded-pill mx-1'
        to={Href}
        title='Ver registro en modo lectura'>
        <span className='fa-solid fa-eye'></span>
    </NavLink>
  )
}
